export default {
  //TODO: REMOVE AND USE NEW TRANSLATIONS
  COULDNT_SEE_ANYONE: `I couldn't see anyone`,
  COULDNT_HEAR_ANYONE: `I couldn't hear anyone`,
  IMAGE_QUALITY_POOR: `Image quality was poor`,
  SOUND_QUALITY_POOR: `Sound quality was poor`,
  TROUBLE_JOINING_CALL: `People had trouble joining the call`,

  HEADER: `Thank you for your patience`,
  TELL_ISSUE_HAVING: `Tell us about the issue you're having`,
  TELL_US_MORE: `Tell us more`,
  REPORT_INFO_OTHER: `Additional report information`,
  MORE_INFO_CONSENT: `Do not use this field to share personal health information or to leave messages intended for your provider. If
  you have questions about your care, please contact your provider's office.`,
  WILL_IMPROVE: `We will use this feedback to continuously improve our products for you.`,

  SEND_FEEDBACK_BUTTON: `Send Feedback`,
  CLOSE_BUTTON: `Close`,

  // NEW TRANSLATIONS
  REPORT_ISSUE_HEADING: `Report Issue`,

  REPORT_ISSUE_TYPE_LABEL: `What issue are you having?`,
  REPORT_ISSUE_TYPE_PLACEHOLDER: `- Type or Select -`,
  REPORT_ISSUE_TYPE_1: `I couldn’t see anyone`,
  REPORT_ISSUE_TYPE_2: `I couldn’t hear anyone`,
  REPORT_ISSUE_TYPE_3: `Image quality was poor`,
  REPORT_ISSUE_TYPE_4: `Sound quality was poor`,
  REPORT_ISSUE_TYPE_5: `People had trouble joining the call`,
  REPORT_ISSUE_TYPE_6: `Other`,
  REPORT_ISSUE_TYPE_ERROR: `Type or select an issue to proceed.`,

  REPORT_ISSUE_EXPLANATION_LABEL_1: `Please explain`,
  REPORT_ISSUE_EXPLANATION_LABEL_2: `(optional)`,
  REPORT_ISSUE_EXPLANATION_PLACEHOLDER: `Tell us what went wrong, and where.`,

  REPORT_ISSUE_NOTIFICATION: `These fields are not intended for your provider. The feedback sent here will be used to improve this web app for you.`,
  REPORT_ISSUE_SEND_FEEDBACK_BUTTON: `Send Feedback`,
  REPORT_ISSUE_SEND_CLOSE_BUTTON: `Close`,
  REPORT_ISSUE_FEEDBACK_SENT: `Feedback Sent`,
  REPORT_ISSUE_FEEDBACK_THANK_YOU: `Thank you for reporting your issue.`,

  // footer
  FOOTER_A11Y_STATEMENT: `Accessibility Statement`,
};
